// extracted by mini-css-extract-plugin
module.exports = {"container":"_3yFZ7GUVxnt-HwKF7YHTDs","heading":"DX5Nz7WEr2B1vjhKdaX7w","headingText":"_25fQHRW3ck3fKCMSQgHS_3","bookMarks":"_36rVXwezWL0wfEjzJdv4oa"};